import { useTranslation } from 'react-i18next'

import useSessionUser from '@/modules/access/hooks/useSessionUser'
import { Accordion } from '@/modules/shared/components/accordion/Accordion'
import { InvoiceIcon } from '@/modules/shared/icons/InvoiceIcon'
import { PlusIcon } from '@/modules/shared/icons/PlusIcon'
import SideNavLink, { SideNavLinkItem } from '@/modules/shared/layouts/side-navigation/SideNavLink'
import { SideBarItem } from '@/modules/shared/layouts/side-navigation/purchaser-navigation/PurchaserNavigation'
import { Themes } from '@/modules/shared/types/Themes'

interface StatementsSideBarItemProps extends SideBarItem {
  statementRoutesMatch: boolean
}

export const StatementsSideBarItem = ({
  statementRoutesMatch,
  openAccordionKey,
  changeOpenAccordionKey,
  onCloseDrawer,
  sideBarIndexKey,
}: StatementsSideBarItemProps) => {
  const { t } = useTranslation()
  const { userPermissions } = useSessionUser()

  const getSideNavLinkItems = () => {
    const sideNavItems: SideNavLinkItem[] = []
    if (userPermissions?.CAN_MANAGE_STATEMENT_RECONCILIATION) {
      sideNavItems.push({
        key: t('statement.newStatement', 'New Statement'),
        target: '/statements/upload',
        icon: <PlusIcon className="size-6 text-gray-500" />,
      })
    }
    sideNavItems.push({
      key: t('general.viewAll', 'View All'),
      target: '/statements',
    })
    return sideNavItems
  }

  return (
    <Accordion
      titlePrefixIcon={<InvoiceIcon className="size-7" />}
      title={t('general.statements', 'Statements')}
      activeColor={statementRoutesMatch ? Themes.Primary : undefined}
      defaultOpen={openAccordionKey === sideBarIndexKey}
      handleTriggerClick={() => changeOpenAccordionKey(sideBarIndexKey)}
      buttonClassName="min-h-11 px-3"
      keepActiveColor
    >
      <SideNavLink
        onCloseDrawer={() => onCloseDrawer()}
        testId="statement-navigation"
        sideNavLinkItems={getSideNavLinkItems()}
      />
    </Accordion>
  )
}
